export default __webpack_public_path__ + "static/media/1.f93c5ffc.png";